import React from 'react';

export const AttributeRow = ({ label, children }) => {
    return (
        <span className='attribute-row'>
            <b>{label}</b>: {children}
        </span>
    );
};
